export const SWAP_default = [{
    taux_fixe: 2
}]



// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/Swap.ts